/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgramModuleSettings } from './ProgramModuleSettings';
import {
    ProgramModuleSettingsFromJSON,
    ProgramModuleSettingsFromJSONTyped,
    ProgramModuleSettingsToJSON,
} from './ProgramModuleSettings';

/**
 * 
 * @export
 * @interface ProgramModuleTemplateAvailableTemplates
 */
export interface ProgramModuleTemplateAvailableTemplates {
    /**
     * 
     * @type {string}
     * @memberof ProgramModuleTemplateAvailableTemplates
     */
    label?: string;
    /**
     * when empty, selection of template is on root level,  when filled, templates with same categoryLabel are grouped and put into the 2nd level
     * @type {string}
     * @memberof ProgramModuleTemplateAvailableTemplates
     */
    categoryLabel?: string;
    /**
     * 
     * @type {Array<ProgramModuleSettings>}
     * @memberof ProgramModuleTemplateAvailableTemplates
     */
    steps?: Array<ProgramModuleSettings>;
}

/**
 * Check if a given object implements the ProgramModuleTemplateAvailableTemplates interface.
 */
export function instanceOfProgramModuleTemplateAvailableTemplates(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProgramModuleTemplateAvailableTemplatesFromJSON(json: any): ProgramModuleTemplateAvailableTemplates {
    return ProgramModuleTemplateAvailableTemplatesFromJSONTyped(json, false);
}

export function ProgramModuleTemplateAvailableTemplatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramModuleTemplateAvailableTemplates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'categoryLabel': !exists(json, 'categoryLabel') ? undefined : json['categoryLabel'],
        'steps': !exists(json, 'steps') ? undefined : ((json['steps'] as Array<any>).map(ProgramModuleSettingsFromJSON)),
    };
}

export function ProgramModuleTemplateAvailableTemplatesToJSON(value?: ProgramModuleTemplateAvailableTemplates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'categoryLabel': value.categoryLabel,
        'steps': value.steps === undefined ? undefined : ((value.steps as Array<any>).map(ProgramModuleSettingsToJSON)),
    };
}

